// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rowQuadrant {

    height: 100%;

}

.rightQuadrant {
    /* width: 25%;
    display: block; */
    width: 100%;
    display: flex;
    height: 12% !important;
    justify-content: center;
    align-items: center;

    z-index: 100 !important;

    position: absolute;
}

.columnEstatusProblem {
    height: 30%;
    width: 19%;
    bottom: 0;
    position: absolute;
}

.column {
    /* height: 40%; */
    height: 95%;
    /* width: 80%; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.columnSmall {
    /* height: 20%; */
    width: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.card {
    position: relative;
    /* background-color: #161935bd; */
    background-color: var(--white-color);
    width: 90%;
    height: 90%;
    /* box-shadow: 5px 5px 10px rgb(32, 32, 32); */
    /* box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4); */
    border-radius: var(--border-radios-small);
    border: 1px solid var(--txt-color);
}

.cardWhite {
    position: relative;
    /* background-color: #6f6f6f; */
    background-color: #161e35d4;
    width: 90%;
    height: 90%;
    /* box-shadow: 5px 5px 10px rgb(32, 32, 32); */
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
    border-radius: 10px;
    border: 1px solid #003757;
}

.menuSearch {
    display: block;
}

.menuSearchData {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
}

.menuSearchColumn {
    width: 25%;
    height: 100%;
    /* border-bottom: 1px solid rgba(255, 255, 255, 0.127); */
    display: flex;
    justify-content: center;
    align-items: center;
}

.menuSearchTitle {
    height: 20%;
    width: 100%;
}

.menuActiontitle {
    height: 14%;
}

.menuInfotitle {
    height: 17%;
}

.menuInfo {
    display: block;
    width: 45%;
}

.menuAction {
    display: block;
    width: 95%;
}

.cardTitle {
    color: var(--main-color);
    font-size: var(--font-size-small);
    color: var(--main-color);
    font-size: var(--font-size-xSmall);
    font-weight: bold;
    letter-spacing: 1px;
    /* background: linear-gradient( #0b1e55, #004d79); */
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border-radius: 10px 10px 0px 0px; */
    background: transparent;
    /* border-bottom: 1px solid #004d79; */
}

.cardTitleG {
    color: #292929;
    background: linear-gradient(#808080, #f9f9f9);
    border-radius: unset;
}

.menuInfo {
    display: block;
}

.menuInfoData {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 85%;
}

.dataContent {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1;
    min-width: 0;
    height: 100%;
    border-left: 1px solid rgba(240, 248, 255, 0.167);
    padding: 3px;
    box-sizing: border-box;
}

.menuActionData {
    /* display: grid;
    justify-content: center;
    width: 100%;
    height: 86%;
    grid-template-columns: 50% 50% ;
    grid-template-rows: 30%; */
    display: grid;
    justify-content: center;
    width: 100%;
    height: 86%;
    grid-template-columns: 1fr 1fr 1fr;
    /* 3 columnas iguales */
    grid-template-rows: repeat(2, 1fr);
    /* 2 filas iguales */
    gap: 5px;
    /* Espacio entre elementos */
    box-sizing: border-box;
    padding: 5px;
}

.menuActionCell {
    border: 1px solid rgba(240, 248, 255, 0.105);
}

.loadSelect {
    font-size: larger;
    color: var(--txt-color);
    font-size: var(--font-size-small);
}

.searchAlert .group {
    width: 80%;
    height: 90%;
}

.searchAlert .group .inputSearch {

    height: 25px;
}

/********************************************************************/
.tooltiptab {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}

.tooltiptab .tooltiptext {
    visibility: hidden;
    width: 300px;
    background-color: rgba(240, 248, 255, 0.947);
    color: var(--txt-color);
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 9999;
    bottom: 135%;
    top: 100%;
    left: 0%;
    margin-left: -115px;
    opacity: 0;
    transition: opacity 0.3s;
    border: 2px solid #354058;
    font-size: small;
    /* font-weight: bold; */
    min-height: 450px;
    overflow: auto;
}

.tooltiptext.up {
    border: 2px solid #0b9515;
}

.InfoData:hover {
    cursor: pointer !important;
}

.tooltiptext.unkonwn {
    border: 2px solid #5c5c5c;
}

.tooltiptext.down {
    border: 2px solid rgb(240, 0, 191);
}

.tooltiptext.odd {
    border: 2px solid #ee0808;
}

.tooltiptext.exception {
    border: 2px solid #330015c9;
}

.infoContadores:hover {
    cursor: pointer;
    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
    background-color: transparent;
}

.tooltiptab .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #555 transparent;
}

.tooltiptab:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
}

.contIncidTab {
    position: relative;
    display: block;
    width: 100%;
    height: 90%;
}

.contExcepTab {
    position: relative;
    display: block;
    width: 100%;
    height: 35%;
    /* border: 1px solid rgba(255, 0, 0, 0.642); */
    border-radius: 0px 0px 10px 10px;
}

.contExcepTab .menuActionData {
    display: flex;
    /* width: 100%; Ajusta esto según sea necesario */
    overflow: auto;
    /* Habilita el scroll horizontal */
    white-space: nowrap;
    /* Evita que el contenido se ajuste en múltiples líneas */
    /* border: 1px solid #ccc; */
    justify-content: start;
}

.contExcepTab .menuActionData .menuActionCell {
    display: inline-block;
    /* Asegura que los elementos estén en una sola línea */
    vertical-align: top;
    /* Alinea los elementos en la parte superior */
    width: 80px;
    /* Ancho de cada elemento */
    /* Ajusta otros estilos según sea necesario */
    height: 85%;
}

.contExcepTab .menuActionData .menuActionCell .dataContentColumn,
.compactData {
    display: block;
    /* Asegura que estos elementos mantengan su comportamiento de bloque */
}

.contExcepTab .menuActionData .menuActionCell .compactData {
    margin: 10px;
    /* Opcional: para dar espacio entre elementos */
}

.compactMenuActionData {
    position: relative;
    width: auto;
    display: flex;
    height: 100%;
    justify-self: start;
}

.titleExeptListRigthQ {
    width: 100%;
    height: 20px;
    color: var(--main-color);
    font-size: var(--font-size-small);
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: rgb(188, 188, 189) 1px solid;

}

.contExeptListRigthQ {
    width: 60%;
    height: auto;
    max-height: 150px;
    background-color: var(--white-color);
    position: absolute;
    top: 100%;
    left: 40%;
    border-radius: 5px 0px 5px 5px;
    border: 1px solid rgb(175, 175, 175);
    overflow: auto;
    z-index: 10;
}

.rowExeptListRigthQ {
    width: 100%;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: var(--border-table-color) solid 1px;
}

.contRowInfoExeptListRigthQ {
    width: 80%;
    height: 80%;
    display: flex;
    justify-content: start;
    align-items: center;
}

.btnExcep {
    /* background-color: white; */
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 2;
    cursor: pointer;
}

/************************Horizontal Movil*************************/
@media (min-width: 500px) and (max-width: 900px) {}

/************************Movil*************************/
@media (max-width: 500px) {
    .contRowInfoExeptListRigthQ {
        font-size: var(--font-size-small) !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/RightQuadrant.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;;AAEhB;;AAEA;IACI;qBACiB;IACjB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;;IAEnB,uBAAuB;;IAEvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iCAAiC;IACjC,oCAAoC;IACpC,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,oDAAoD;IACpD,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,2BAA2B;IAC3B,UAAU;IACV,WAAW;IACX,8CAA8C;IAC9C,8CAA8C;IAC9C,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yDAAyD;IACzD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;AACd;;AAEA;IACI,wBAAwB;IACxB,iCAAiC;IACjC,wBAAwB;IACxB,kCAAkC;IAClC,iBAAiB;IACjB,mBAAmB;IACnB,oDAAoD;IACpD,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;IACtC,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,YAAY;IACZ,YAAY;IACZ,iDAAiD;IACjD,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI;;;;;8BAK0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,WAAW;IACX,kCAAkC;IAClC,uBAAuB;IACvB,kCAAkC;IAClC,oBAAoB;IACpB,QAAQ;IACR,4BAA4B;IAC5B,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA,qEAAqE;AACrE;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,4CAA4C;IAC5C,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,8CAA8C;IAC9C,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;IACX,8CAA8C;IAC9C,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,iDAAiD;IACjD,cAAc;IACd,kCAAkC;IAClC,mBAAmB;IACnB,yDAAyD;IACzD,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sDAAsD;IACtD,mBAAmB;IACnB,8CAA8C;IAC9C,WAAW;IACX,2BAA2B;IAC3B,6CAA6C;IAC7C,WAAW;AACf;;AAEA;;IAEI,cAAc;IACd,sEAAsE;AAC1E;;AAEA;IACI,YAAY;IACZ,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,2CAA2C;;AAE/C;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,oCAAoC;IACpC,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,8BAA8B;IAC9B,oCAAoC;IACpC,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA,kEAAkE;AAClE,kDAAkD;;AAElD,uDAAuD;AACvD;IACI;QACI,4CAA4C;IAChD;AACJ","sourcesContent":[".rowQuadrant {\r\n\r\n    height: 100%;\r\n\r\n}\r\n\r\n.rightQuadrant {\r\n    /* width: 25%;\r\n    display: block; */\r\n    width: 100%;\r\n    display: flex;\r\n    height: 12% !important;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    z-index: 100 !important;\r\n\r\n    position: absolute;\r\n}\r\n\r\n.columnEstatusProblem {\r\n    height: 30%;\r\n    width: 19%;\r\n    bottom: 0;\r\n    position: absolute;\r\n}\r\n\r\n.column {\r\n    /* height: 40%; */\r\n    height: 95%;\r\n    /* width: 80%; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.columnSmall {\r\n    /* height: 20%; */\r\n    width: 20%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.card {\r\n    position: relative;\r\n    /* background-color: #161935bd; */\r\n    background-color: var(--white-color);\r\n    width: 90%;\r\n    height: 90%;\r\n    /* box-shadow: 5px 5px 10px rgb(32, 32, 32); */\r\n    /* box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4); */\r\n    border-radius: var(--border-radios-small);\r\n    border: 1px solid var(--txt-color);\r\n}\r\n\r\n.cardWhite {\r\n    position: relative;\r\n    /* background-color: #6f6f6f; */\r\n    background-color: #161e35d4;\r\n    width: 90%;\r\n    height: 90%;\r\n    /* box-shadow: 5px 5px 10px rgb(32, 32, 32); */\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n    border-radius: 10px;\r\n    border: 1px solid #003757;\r\n}\r\n\r\n.menuSearch {\r\n    display: block;\r\n}\r\n\r\n.menuSearchData {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.menuSearchColumn {\r\n    width: 25%;\r\n    height: 100%;\r\n    /* border-bottom: 1px solid rgba(255, 255, 255, 0.127); */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.menuSearchTitle {\r\n    height: 20%;\r\n    width: 100%;\r\n}\r\n\r\n.menuActiontitle {\r\n    height: 14%;\r\n}\r\n\r\n.menuInfotitle {\r\n    height: 17%;\r\n}\r\n\r\n.menuInfo {\r\n    display: block;\r\n    width: 45%;\r\n}\r\n\r\n.menuAction {\r\n    display: block;\r\n    width: 95%;\r\n}\r\n\r\n.cardTitle {\r\n    color: var(--main-color);\r\n    font-size: var(--font-size-small);\r\n    color: var(--main-color);\r\n    font-size: var(--font-size-xSmall);\r\n    font-weight: bold;\r\n    letter-spacing: 1px;\r\n    /* background: linear-gradient( #0b1e55, #004d79); */\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* border-radius: 10px 10px 0px 0px; */\r\n    background: transparent;\r\n    /* border-bottom: 1px solid #004d79; */\r\n}\r\n\r\n.cardTitleG {\r\n    color: #292929;\r\n    background: linear-gradient(#808080, #f9f9f9);\r\n    border-radius: unset;\r\n}\r\n\r\n.menuInfo {\r\n    display: block;\r\n}\r\n\r\n.menuInfoData {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 85%;\r\n}\r\n\r\n.dataContent {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex: 1;\r\n    min-width: 0;\r\n    height: 100%;\r\n    border-left: 1px solid rgba(240, 248, 255, 0.167);\r\n    padding: 3px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.menuActionData {\r\n    /* display: grid;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 86%;\r\n    grid-template-columns: 50% 50% ;\r\n    grid-template-rows: 30%; */\r\n    display: grid;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 86%;\r\n    grid-template-columns: 1fr 1fr 1fr;\r\n    /* 3 columnas iguales */\r\n    grid-template-rows: repeat(2, 1fr);\r\n    /* 2 filas iguales */\r\n    gap: 5px;\r\n    /* Espacio entre elementos */\r\n    box-sizing: border-box;\r\n    padding: 5px;\r\n}\r\n\r\n.menuActionCell {\r\n    border: 1px solid rgba(240, 248, 255, 0.105);\r\n}\r\n\r\n.loadSelect {\r\n    font-size: larger;\r\n    color: var(--txt-color);\r\n    font-size: var(--font-size-small);\r\n}\r\n\r\n.searchAlert .group {\r\n    width: 80%;\r\n    height: 90%;\r\n}\r\n\r\n.searchAlert .group .inputSearch {\r\n\r\n    height: 25px;\r\n}\r\n\r\n/********************************************************************/\r\n.tooltiptab {\r\n    position: relative;\r\n    display: inline-block;\r\n    /* border-bottom: 1px dotted black; */\r\n}\r\n\r\n.tooltiptab .tooltiptext {\r\n    visibility: hidden;\r\n    width: 300px;\r\n    background-color: rgba(240, 248, 255, 0.947);\r\n    color: var(--txt-color);\r\n    text-align: center;\r\n    border-radius: 6px;\r\n    padding: 5px 0;\r\n    position: absolute;\r\n    z-index: 9999;\r\n    bottom: 135%;\r\n    top: 100%;\r\n    left: 0%;\r\n    margin-left: -115px;\r\n    opacity: 0;\r\n    transition: opacity 0.3s;\r\n    border: 2px solid #354058;\r\n    font-size: small;\r\n    /* font-weight: bold; */\r\n    min-height: 450px;\r\n    overflow: auto;\r\n}\r\n\r\n.tooltiptext.up {\r\n    border: 2px solid #0b9515;\r\n}\r\n\r\n.InfoData:hover {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.tooltiptext.unkonwn {\r\n    border: 2px solid #5c5c5c;\r\n}\r\n\r\n.tooltiptext.down {\r\n    border: 2px solid rgb(240, 0, 191);\r\n}\r\n\r\n.tooltiptext.odd {\r\n    border: 2px solid #ee0808;\r\n}\r\n\r\n.tooltiptext.exception {\r\n    border: 2px solid #330015c9;\r\n}\r\n\r\n.infoContadores:hover {\r\n    cursor: pointer;\r\n    box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n    background-color: transparent;\r\n}\r\n\r\n.tooltiptab .tooltiptext::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    bottom: 100%;\r\n    left: 50%;\r\n    margin-left: -5px;\r\n    border-width: 5px;\r\n    border-style: solid;\r\n    border-color: transparent transparent #555 transparent;\r\n}\r\n\r\n.tooltiptab:hover .tooltiptext {\r\n    visibility: visible;\r\n    opacity: 1;\r\n}\r\n\r\n.contIncidTab {\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 90%;\r\n}\r\n\r\n.contExcepTab {\r\n    position: relative;\r\n    display: block;\r\n    width: 100%;\r\n    height: 35%;\r\n    /* border: 1px solid rgba(255, 0, 0, 0.642); */\r\n    border-radius: 0px 0px 10px 10px;\r\n}\r\n\r\n.contExcepTab .menuActionData {\r\n    display: flex;\r\n    /* width: 100%; Ajusta esto según sea necesario */\r\n    overflow: auto;\r\n    /* Habilita el scroll horizontal */\r\n    white-space: nowrap;\r\n    /* Evita que el contenido se ajuste en múltiples líneas */\r\n    /* border: 1px solid #ccc; */\r\n    justify-content: start;\r\n}\r\n\r\n.contExcepTab .menuActionData .menuActionCell {\r\n    display: inline-block;\r\n    /* Asegura que los elementos estén en una sola línea */\r\n    vertical-align: top;\r\n    /* Alinea los elementos en la parte superior */\r\n    width: 80px;\r\n    /* Ancho de cada elemento */\r\n    /* Ajusta otros estilos según sea necesario */\r\n    height: 85%;\r\n}\r\n\r\n.contExcepTab .menuActionData .menuActionCell .dataContentColumn,\r\n.compactData {\r\n    display: block;\r\n    /* Asegura que estos elementos mantengan su comportamiento de bloque */\r\n}\r\n\r\n.contExcepTab .menuActionData .menuActionCell .compactData {\r\n    margin: 10px;\r\n    /* Opcional: para dar espacio entre elementos */\r\n}\r\n\r\n.compactMenuActionData {\r\n    position: relative;\r\n    width: auto;\r\n    display: flex;\r\n    height: 100%;\r\n    justify-self: start;\r\n}\r\n\r\n.titleExeptListRigthQ {\r\n    width: 100%;\r\n    height: 20px;\r\n    color: var(--main-color);\r\n    font-size: var(--font-size-small);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: rgb(188, 188, 189) 1px solid;\r\n\r\n}\r\n\r\n.contExeptListRigthQ {\r\n    width: 60%;\r\n    height: auto;\r\n    max-height: 150px;\r\n    background-color: var(--white-color);\r\n    position: absolute;\r\n    top: 100%;\r\n    left: 40%;\r\n    border-radius: 5px 0px 5px 5px;\r\n    border: 1px solid rgb(175, 175, 175);\r\n    overflow: auto;\r\n    z-index: 10;\r\n}\r\n\r\n.rowExeptListRigthQ {\r\n    width: 100%;\r\n    height: 30px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: var(--border-table-color) solid 1px;\r\n}\r\n\r\n.contRowInfoExeptListRigthQ {\r\n    width: 80%;\r\n    height: 80%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n\r\n.btnExcep {\r\n    /* background-color: white; */\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    z-index: 2;\r\n    cursor: pointer;\r\n}\r\n\r\n/************************Horizontal Movil*************************/\r\n@media (min-width: 500px) and (max-width: 900px) {}\r\n\r\n/************************Movil*************************/\r\n@media (max-width: 500px) {\r\n    .contRowInfoExeptListRigthQ {\r\n        font-size: var(--font-size-small) !important;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
